// extracted by mini-css-extract-plugin
export default {"utility":"Utility_utility__exOdD","container":"Utility_container__vt7+r","blocks":"Utility_blocks__Egr9e","block":"Utility_block__dNP7Y"};